module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "terminal-wrapper"
  }, [_c('div', {
    staticClass: "terminal-topbar"
  }, [_c('svg', {
    attrs: {
      "width": "500px",
      "height": "100px",
      "viewBox": "0 0 500 100",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group"
    }
  }, [_c('circle', {
    attrs: {
      "id": "Oval",
      "fill": "#F62834",
      "cx": "50",
      "cy": "50",
      "r": "50"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "Oval",
      "fill": "#8BAF1B",
      "cx": "250",
      "cy": "50",
      "r": "50"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "Oval",
      "fill": "#FBAC3E",
      "cx": "450",
      "cy": "50",
      "r": "50"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "terminal-inner bg-deveo-light"
  }, [(_vm.showTerminal) ? _c('pre', [_c('vue-typer', {
    attrs: {
      "text": ["$ vue init deveodk/vue-core"],
      "repeat": 0,
      "shuffle": true,
      "initial-action": "typing",
      "pre-type-delay": 0,
      "type-delay": 140,
      "pre-erase-delay": 30000,
      "erase-delay": 0,
      "erase-style": "clear",
      "erase-on-complete": false,
      "caret-animation": "smooth"
    }
  }), _vm._v("\n\n"), _c('vue-typer', {
    attrs: {
      "text": ["Project name: "],
      "repeat": 0,
      "shuffle": true,
      "initial-action": "typing",
      "pre-type-delay": 4000,
      "type-delay": 0,
      "pre-erase-delay": 30000,
      "erase-delay": 0,
      "erase-style": "clear",
      "erase-on-complete": false,
      "caret-animation": "smooth"
    }
  }), _c('vue-typer', {
    attrs: {
      "text": ["awesome-project"],
      "repeat": 0,
      "shuffle": true,
      "initial-action": "typing",
      "pre-type-delay": 4500,
      "type-delay": 140,
      "pre-erase-delay": 30000,
      "erase-delay": 0,
      "erase-style": "clear",
      "erase-on-complete": false,
      "caret-animation": "smooth"
    }
  }), _vm._v("\n\n    "), _c('vue-typer', {
    attrs: {
      "text": ["Generated: awesome-project"],
      "repeat": 0,
      "shuffle": true,
      "initial-action": "typing",
      "pre-type-delay": 7000,
      "type-delay": 0,
      "pre-erase-delay": 30000,
      "erase-delay": 0,
      "erase-style": "clear",
      "erase-on-complete": false,
      "caret-animation": "smooth"
    }
  }), _vm._v("\n\n"), _c('vue-typer', {
    attrs: {
      "text": ["$ cd awesome-project"],
      "repeat": 0,
      "shuffle": true,
      "initial-action": "typing",
      "pre-type-delay": 8000,
      "type-delay": 140,
      "pre-erase-delay": 30000,
      "erase-delay": 0,
      "erase-style": "clear",
      "erase-on-complete": false,
      "caret-animation": "smooth"
    }
  }), _vm._v("\n"), _c('vue-typer', {
    attrs: {
      "text": ["$ npm install"],
      "repeat": 0,
      "shuffle": true,
      "initial-action": "typing",
      "pre-type-delay": 11500,
      "type-delay": 140,
      "pre-erase-delay": 30000,
      "erase-delay": 0,
      "erase-style": "clear",
      "erase-on-complete": false,
      "caret-animation": "smooth"
    }
  }), _vm._v("\n"), _c('vue-typer', {
    attrs: {
      "text": ["$ npm run dev"],
      "repeat": 0,
      "shuffle": true,
      "initial-action": "typing",
      "pre-type-delay": 13500,
      "type-delay": 140,
      "pre-erase-delay": 30000,
      "erase-delay": 0,
      "erase-style": "clear",
      "erase-on-complete": false,
      "caret-animation": "smooth"
    }
  }), _vm._v("\n")], 1) : _c('pre', [_vm._v("\n\n\n\n\n\n\n\n\n")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f81dd1ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/technology/components/terminal.vue
// module id = 321
// module chunks = 1